import store from '../state/store'
import Vue from 'vue'
export default [
  

  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/Anasayfa/Index'),
    beforeEnter(to,from,next){ 
      if(store.getters.["auth/isAuth"]){
        next()
      }else{
        window.location=Vue.prototype.$config.LOGIN_URL
      }
    }
  },
  {
    path: '/AnktForm/:AnktAnketId',
    name: 'AnktForm',
    meta: { authRequired: true },
    component: () => import('./views/AnktForm/Index'),
    beforeEnter(to,from,next){ 
      if(store.getters.["auth/isAuth"]){
        next()
      }else{
        window.location=Vue.prototype.$config.LOGIN_URL
      }
    }
  },
  {
    path: '/AnktAnket',
    name: 'AnktAnket',
    meta: { authRequired: true },
    component: () => import('./views/AnktAnket/Index'),
    beforeEnter(to,from,next){ 
      if(store.getters.["auth/isAuth"]){
        next()
      }else{
        window.location=Vue.prototype.$config.LOGIN_URL
      }
    }
    
  },
  {
    path: '/AnktAnketCevap/:AnktAnketId',
    name: 'AnktAnketCevap',
    meta: { authRequired: true },
    component: () => import('./views/AnktAnketCevap/Index')
  },
  {
    path: '/AnktAnketCevap/:AnktAnketId/:Sessionkey/:Email',
    name: 'AnktAnketCevap',
    meta: { authRequired: true },
    component: () => import('./views/AnktAnketCevap/Index')
  },
  {
    path: '/AnktDetay/:AnktAnketId',
    name: 'AnktDetay',
    meta: { authRequired: true },
    component: () => import('./views/AnktDetay/Index')
  },
  {
    path: '/AnktAyarlar',
    name: 'AnktAyarlar',
    meta: { authRequired: true },
    component: () => import('./views/AnktAyarlar/Index')
  },
  {
    path: '/logout',
    name: 'logout', 
    beforeEnter(to,from,next){  
    store.dispatch("auth/logOut") 
        next("/login") 
    },
     
  },
  
  {
    path: '/userroles',
    name: 'userroles', 
    component: () => import('./views/userroles/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            next("/login") 
          }
     }
  },
  {
    path: '/ouserbirimyetki',
    name: 'ouserbirimyetki', 
    component: () => import('./views/ouserbirimyetki/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            next("/login") 
          }
     }
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  }, 
  {
    path: '*',
    redirect: '404',
  }, 
  {
    path: '/:Sessionkey/:Email',
    name: 'default',
    component: () => import('./views/Anasayfa/Index'),
 
  },
  
]
